<template>
  <v-container>

    <v-row>
      <v-snackbar
        top
        v-model="snackbar"
        :color="color"
        :timeout="6000"
      >
        {{mensaje}}
        <v-btn text dark @click.native="snackbar = false" >Close</v-btn>
      </v-snackbar>

      <v-col cols="12">
        <!-- Buscador -->
        <v-card-title primary-title>
          <v-text-field
            dense
            outlined
            rounded
            hide-details
            label="Búscar"
            v-model="search"
            append-icon="mdi-search"
          ></v-text-field>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-btn  class="success ml-2" icon dark @click="initialize" ><v-icon>mdi-refresh</v-icon> </v-btn>
        </v-card-title>
      </v-col>

      <!-- Catalago en forma de carts -->
      <v-col cols="12" xl="4" lg="4" md="6"  v-for="(a, i) in filterUsuarios" :key="i">
        <!-- usuarios -->
        <v-card class="ma-2 elevation-12">
          <v-row>
            <v-col cols="12" >
              <v-card-text align="center" class="mb-0 pb-0 text-h5">
               <b>{{a.usuario.nombre_usuario}}</b><br/>
              </v-card-text>
              <v-card-title primary-title class="mt-0 pt-0">
                Accesos 
              <v-btn 
                  color="blue" icon 
                  @click="dialogAddAcceso = true, 
                  idselectUser = a.usuario.id, 
                  accessosUser = a.accesos
                  obtener_carpetas_disponibles()"
                ><v-icon>mdi-plus-circle</v-icon>
              </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-data-table
                :loading="loading"
                :headers="headersAccesos"
                :items="a.accesos"
                fixed-header
                :height="200"
                hide-default-footer
                loading-text="Cargando..."
                dense
                :items-per-page="100"
                :mobile-breakpoint="250"
                >
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="error"
                    small
                    @click="dialogDeleteAcceso = true, 
                            idAccesoEliminar = item.idaccesos_usuarios_carpetas"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                </v-card-title>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    

    <!-- Eliminar la acceso de un articulo -->
    <v-row justify="center">
      <v-dialog v-model="dialogDeleteAcceso" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Eliminar Acceso</v-card-title>
          <v-card-text>¿Deseas eliminar permanentemente el acceso?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogDeleteAcceso = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="deleteAcceso">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Agregar carpetas al artículo -->
    <v-row justify="center">
      <v-dialog v-model="dialogAddAcceso" persistent max-width="350">
        <v-card>
          <v-card-title class="headline pa-4">Agregar acceso</v-card-title>
          <v-card-text>
            <v-select 
              filled
              :items="carpetas"
              v-model="carpeta"
              item-text="carpeta"
              item-value="idcarpetas" 
              label="Carpetas"
              persistent-hint
              single-line
              hide-details
              return-object
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogAddAcceso = false">Cancelar</v-btn>
            <v-btn color="success" @click="agregarAcceso()">Agregar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


  </v-container>
</template>

<script>
 import {mapActions, mapGetters} from 'vuex'

  export default {
    data: () => ({
      // Alerta
      snackbar:false,
      color:'',
      mensaje:'',
      // modo
      modo: 1, // 1 nuevo, 2 editar,

      // nuevo articulo
      dialog: false,

      idruta:0,
      mensaje:'',
      dialogAddAcceso: false,
      dialogDeleteAcceso:false,
      loading:true,

      idAccesoEliminar: null,
      idselectUser:0,
      accessosUser:[],
      dialogDeleteArt: false,
      
      carpetas:[],
      carpeta:{idcarpetas:'', carpeta:''},
      headersAccesos: [
        { text: 'id', align: 'start', value: 'idaccesos_usuarios_carpetas'},
        { text: 'Carpeta', align: 'start', value: 'nombre_carpeta'},
        { text: 'Acciones', align: 'end', value: 'actions'},
      ],

      usuarios: [],
      search:'',
      longitud:100,
    }),


    watch: {
      dialog (val) {
        val || this.close()
      },
    }, 

    created () {
      this.initialize()
      //this.url = this.$http.options.root + 'fotos/'
    },

    methods: {
      initialize () {
        this.usuarios = []
        this.$http.get('users.accesos.carpetas').then(response=>{
          this.usuarios = response.body
          this.longitud = this.usuarios.length
          this.loading = false
        }).catch(error=>{console.log(error)})
      },


      obtener_carpetas_disponibles(){
        this.$http.get('carpetas.disponibles').then(response=>{
          this.carpetas = response.body
        }).catch(error=>{console.log(error)})
      },

      agregarAcceso(){
        for(let i = 0 ; i < this.accessosUser.length; i++){
          if(this.accessosUser[i].id_carpetas == this.carpeta.idcarpetas){
              this.mensaje = 'La carpeta ' +  this.carpeta.carpeta + ' ya existe en los accesos'
              this.color = 'error'
              this.snackbar = true
              return 
          }
        }

         let  payload ={
          idusuario: this.idselectUser,
          idcarpeta: this.carpeta.idcarpetas
        }
  
        this.$http.post('agregar.acceso', payload).then(response=>{
          this.mensaje = response.body.message
          this.color = 'success'
          this.snackbar = true;
          this.initialize();
          this.dialogAddAcceso = false;
          this.carpeta = {idcarpetas:'', carpeta:''}
        }).catch(error=>{console.log(error)})
        
      },

      deleteAcceso(){
        this.$http.delete('eliminar.acceso/' + this.idAccesoEliminar).then(response=>{
          this.mensaje = response.body.message
          this.color = 'error'
          this.snackbar = true
          this.initialize();
          this.dialogDeleteAcceso = false;
        }).catch(error=>console.log(error))
      },


    },

    computed:{

      filterUsuarios: function(){
        var me = this
        if(this.usuarios){
          return this.usuarios.filter((art)=>{
            var nom = art.usuario.nombre_usuario.toLowerCase();
            return nom.match(this.search.toLowerCase());
          })
        }
      },
    }
  }
</script>
